export default __webpack_public_path__ + "static/media/flag-chad.5d80352a.svg";